export default {
  getApproval: "/wechat/getapprovallist",
  getApprovalDetails: "/wechat/getapprovaldetails/{id}",
  downloadpdf: "/wechat/downloadpdf/{id}",
  confirmPayment: "/wechat/confirmpayment/{id}",
}



// WEBPACK FOOTER //
// ./src/api/config/reimburse.js